import * as React from "react";
import { withTheme } from "styled-components";

import Modal from "../../../../modals/smart/modal/modal";
import { BodyContainer } from "../../../../modals/smart/modal/modal-style";
import { InviteUserToAppModalStyle } from "./invite-user-to-app-modal-style";
import { RuntimeTheme } from "webapp/lib/theme/default-theme";
import { isValidEmailAddress } from "common/Support";
import { withModalProvider } from "designer/modals-v2/modal-provider-v2/modal-provider-v2";
import { SimpleModalContextProps } from "designer/modals-v2/modal-provider-v2/modal-context";

interface Props {
    readonly withCopy: boolean;
    readonly theme: RuntimeTheme;
    readonly onCompletion: (email: string | false) => void;
    readonly modals: SimpleModalContextProps;
}

interface State {
    email: string;
}

class InviteUserToAppModal extends React.PureComponent<Props, State> {
    public state: State = {
        email: "",
    };

    private complete(email: string | false) {
        const { onCompletion } = this.props;
        if (onCompletion) {
            onCompletion(email);
        }
    }

    private onCancel = () => {
        this.complete(false);
    };

    private onAccept = async () => {
        const { email } = this.state;
        this.props.modals.DEPRECATED_removeAllModals();
        this.complete(email);
    };

    private onEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            email: event.target.value,
        });
    };

    public render(): React.ReactNode {
        const { withCopy } = this.props;
        const { email } = this.state;

        return (
            <Modal
                height={530}
                width={400}
                title={withCopy ? "Copy app to user" : "Transfer app to user"}
                canAccept={isValidEmailAddress(email)}
                onAccept={this.onAccept}
                onClose={this.onCancel}
                animate={false}
                acceptText={withCopy ? "Copy" : "Transfer"}>
                <BodyContainer>
                    {withCopy && (
                        <div>
                            The app will be copied when the recipient accepts it, so please make sure that any changes
                            you make until then are ok with the recipient.
                        </div>
                    )}
                    <InviteUserToAppModalStyle>
                        <div className="header">Please enter the email address of the recipient:</div>
                        <input
                            className="form-input emailInput"
                            placeholder="Email"
                            value={email}
                            onChange={this.onEmailChange}
                        />
                    </InviteUserToAppModalStyle>
                </BodyContainer>
            </Modal>
        );
    }
}

export default withModalProvider(withTheme(InviteUserToAppModal));
